import { Component, Input } from '@angular/core';
import { IconComponent } from '@totalenergiescode/tds-angular';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';

@Component({
    selector: 'app-info-icon-tooltip',
    imports: [
        IconComponent,
        MatTooltip,
    ],
    templateUrl: './info-icon-tooltip.component.html'
})
export class InfoIconTooltipComponent {
  @Input({ required: true }) text: string;
  @Input() position: TooltipPosition = 'right';
}
